import React from 'react';
import { InfoIcon } from 'lucide-react';
import { Tooltip } from './Tooltip';
interface LabelWithInfoProps {
  label: string;
  tooltip: string;
}
export function LabelWithInfo({
  label,
  tooltip
}: LabelWithInfoProps) {
  return <div className="flex items-center mb-3" data-id="element-726" data-mp="1c7fis90a7t0l">
      <label className="block text-sm font-semibold text-gray-900" data-id="element-727" data-mp="1h58rp9syz14k">
        {label}
      </label>
      <Tooltip content={tooltip} data-id="element-728" data-mp="24ut93o9h5qbq">
        <button type="button" aria-label="Meer informatie" className="ml-2 text-gray-400 hover:text-[#007AFF] focus:outline-none" data-id="element-729" data-mp="24vumhzdyqowm">
          <InfoIcon className="w-4 h-4" data-id="element-730" data-mp="1v59q8ilrhwgv" />
        </button>
      </Tooltip>
    </div>;
}